import { ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';
import { Datatype } from '../../../../../../expressions/datatype/Datatype';
import { formatIsoCalendarDate } from '../../../date/formatIsoCalendarDate';
import { IAsyncSelectWidget } from '../../IAsyncSelectWidget';

type IInputType = Pick<IAsyncSelectWidget, 'table' | 'outputs'>;

function getColumns(widget: IInputType): ColumnsType<any> {
  const result: ColumnsType<any> = [];

  for (const col of widget.table?.columns ?? []) {
    const output = widget.outputs?.find(o => o.name === col.value);
    const column = {
      title: col.label,
      dataIndex: col.value,
      key: col.value,
      render:
        output?.type.type === Datatype.Date
          ? (value: string) => formatIsoCalendarDate(value)
          : undefined,
    };

    result.push(column);
  }

  return result;
}

export function useAsyncServiceTableColumns(
  widget: IInputType,
): ColumnsType<any> {
  const columns = useMemo(() => getColumns(widget), [widget]);
  return columns;
}
